import { FC } from "react";
import { FieldCommonProps } from "./SlideOverFieldsGroups/types";
import { NamedSelect } from "../../../molecules/NamedSelect";
import { NamedTextInput } from "../../../molecules/NamedTextInput";
import { NamedNumberic } from "../../../molecules/NamedNumberic";
import { StyleVariant } from "../../../molecules/types";
import { NamedRow } from "../../../../../components/GeneralUI/NamedRow/NamedRow";
import { parseNumberOrZero } from "../../../../../helpers";

export const NamedField: FC<
  FieldCommonProps & {
    title?: string;
    value: string | number;
    fieldKey: string;
    styleVariant?: StyleVariant;
  }
> = (item) => {
  const {
    title,
    fieldKey,
    value,
    type,
    options,
    onClick,
    editPermissions,
    disabled,
    ...rest
  } = item;
  const renderTitle = title ?? `${fieldKey.split(/(?=[A-Z])/).join(" ")}`;
  if (onClick)
    return (
      <NamedRow
        title={renderTitle}
        content={String(value)}
        onClick={onClick}
        editPermissions={editPermissions}
      />
    );
  if (type === "number" || typeof value === "number")
    return (
      <NamedNumberic
        {...rest}
        disabled={disabled}
        value={parseNumberOrZero(String(value))}
        title={renderTitle}
      />
    );
  else {
    const commonProps = {
      ...rest,
      disabled,
      type,
      value,
      title: renderTitle,
    };
    if (options) {
      // A disabled <select> still looks clickable (dropdown chevron, hover state),
      // which reads as "why can't I edit this?" — show plain disabled text instead,
      // resolved to the matching option's label rather than the raw stored value.
      if (disabled) {
        const matched = options.find((o) =>
          typeof o === "string" ? o === value : o.value === value,
        );
        const label =
          typeof matched === "string"
            ? matched
            : (matched?.title ?? String(value));
        return <NamedTextInput {...commonProps} value={label} />;
      }
      return <NamedSelect {...commonProps} options={options} />;
    }
    return (
      <NamedTextInput
        {...commonProps}
        type={fieldKey === "url" ? "url" : type}
        textArea={disabled && value.length > 60}
      />
    );
  }
};
